import { Box } from '@mui/material';
import { CheckboxGroupInput, required, useTranslate } from 'react-admin';

import { ShowSection } from '@sh4res/bo-common/components';
import { BeneficiaryDetailsShow } from '@sh4res/bo-common/components/B2bSavingsFundRequests/B2bSavingsFundRequestsPayment/steps/PaymentStep';
import { CurrencyField } from '@sh4res/bo-common/fields';

const testId = 'BoExternalB2bSavingsFundRequestsPaymentConfirmationStep';

export const ConfirmationStep = ({ payment_amount }: { payment_amount: number }) => {
  const translate = useTranslate();

  return (
    <Box>
      <ShowSection
        leftAligned
        label="resources.bo_common.b2b.savings_funds_requests.payments.amount_paid"
        noCard={true}>
        <CurrencyField
          currency="EUR"
          record={{ payment_amount }}
          source="payment_amount"
          testId={`${testId}_PaymentAmountField`}
        />
      </ShowSection>
      <ShowSection
        leftAligned
        label="resources.bo_common.b2b.savings_funds_requests.payments.beneficiary_details"
        noCard={true}>
        <BeneficiaryDetailsShow />
      </ShowSection>
      <ShowSection
        leftAligned
        label="resources.bo_common.b2b.savings_funds_requests.payments.confirmation_title"
        noCard={true}>
        <CheckboxGroupInput
          data-testid={`${testId}_ConfirmPaymentCheckbox`}
          source="confirm_payment"
          label={false}
          isRequired
          validate={[required()]}
          choices={[
            {
              id: 'si',
              name: translate(
                'resources.bo_common.b2b.savings_funds_requests.payments.confirmation',
              ),
            },
          ]}
        />
      </ShowSection>
    </Box>
  );
};
